/**
 * Formats a git repository URL for display by removing the protocol and optional .git suffix
 * @param url - The repository URL to format
 * @returns The formatted URL without protocol and .git suffix
 */
export function formatRepoUrlForDisplay(url: string | undefined, omitHost?: boolean): string {
    if (!url) {
        return "No URL";
    }

    if (omitHost) {
        // If we are omitting the host, we only want the path part of the URL
        const parsedUrl = new URL(url);
        return parsedUrl.pathname.replace(/\.git$/, "").replace(/\//, ""); // Remove trailing .git and leading slash
    }

    return url
        .replace(/https?:\/\//, "") // Remove http:// or https://
        .replace(/\.git$/, ""); // Remove trailing .git
}
